<template>

  <b-container class="pt-4">
    <b-row class="d-flex flex-row justify-content-center ">
      <b-col xl="6" lg="6" md="6" sm="12" class="d-flex flex-column align-items-center  stand-up-animation"
             v-for="restaurant in restaurants" :key="restaurant.id">

        <b-card class="my-4 shadow-lg w-100" :img-src="restaurant.image" :img-alt="restaurant.name" img-top>
          <b-row>
            <b-col lg="7" md="7" sm="12" class="d-flex flex-column align-items-center">
              <b-row class="d-flex flex-row justify-content-center">
                <router-link :to="{ name: 'FoodsList', params:{slug:restaurant.slug} }">
                <h3 class="text-dark">{{ restaurant.name }}</h3>
                </router-link>
              </b-row>
            </b-col>
            <b-col lg="5" md="5" sm="12" class="mt-2 d-flex flex-column align-items-center">
              <b-row class="d-flex flex-row justify-content-center" v-if="restaurant.rate !== null">
                <div class="justify-center" v-for="i in 5" :key="i+restaurant.id" >
                  <b-icon icon="star-fill" font-scale="1" variant="warning" v-if="i <= restaurant.rate"/>
                  <b-icon icon="star" font-scale="1" variant="warning" v-else/>
                </div>
              </b-row>
              <b-row class="d-flex flex-row justify-content-center" v-else>
                <div class="justify-center" v-for="i in 5" :key="i+restaurant.id">
                  <b-icon icon="star" font-scale="1" variant="warning"/>
                </div>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" md="6" sm="12"
                   class="d-flex flex-column align-items-center d-flex flex-row justify-content-center pt-2 pb-2">
              <b-button pill class="px-3 show-comments border-0 bg-secondary"
                        @click="getRestaurantComment(restaurant.id, restaurant.name)"
                        v-b-toggle.restaurant-comments>نظرات
              </b-button>
            </b-col>
            <b-col lg="6" md="6" sm="12"
                   class="d-flex flex-column align-items-center d-flex flex-row justify-content-center pt-2 pb-2">
              <router-link :to="{ name: 'FoodsList', params:{slug:restaurant.slug} }">
                <b-button class="rounded-circle go2restaurant border-0">
                  <b-icon class=" text-dark" icon="arrow-right"/>
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card>

      </b-col>




      <C4Comments :comments="comments" :restaurant_id="restaurant_id" :restaurant_name="restaurant_name"/>

    </b-row>
  </b-container>

</template>
<script>

import C4Comments from "./C6Comments";
import {mapGetters} from "vuex";

export default {
  name: "C6",
  components: {C4Comments},
  data() {
    return {
      restaurant_id: '',
      restaurant_name: ''
    }
  },
  computed: {
    ...mapGetters({
      restaurants: "Brand/getBrands",
      comments: 'Comment/getComments'
    })
  },
  methods: {
    getRestaurantComment(restaurantId, restaurantName) {
      this.restaurant_id = restaurantId
      this.restaurant_name = restaurantName
      let form = {id: restaurantId, comment_type: 'brand'}
      this.$store.dispatch("Comment/getClientComments", form)

    }
  },
  mounted() {
    this.$store.dispatch("Brand/getBrands")
  }
}
</script>
<style scoped>
.card {
  border-radius: 40px 40px 30px 30px;
  min-width: 200px;
  max-width: 500px;
  font-family: 'Avini', 'Vazir', sans-serif !important;
}

.card-body {
  position: absolute;
  bottom: -26px;
  border-radius: 30px;
  background-color: white;
  width: 100%;

}

.card-img-top {
  border-radius: 40px 40px 0 0;
  width: 100%;
}

.go2restaurant {
  width: 43px;
  height: 43px;
  background-color: var(--primary) !important;
  color: var(--dark) !important;
}


hr {
  border: 1px solid grey;
  width: 80%;
}

@media screen and (max-width: 500px) {
  .card {
    border-radius: 20px;
  }

  .card-body {
    position: initial;
    bottom: 0;
    border-radius: 20px;
    background-color: white;
    width: 100%;

  }

  .card-img-top {
    border-radius: 20px 20px 0 0;
  }
}

.show-comments{
  background-color: var(--secondary) !important;
  color: var(--light) !important;
}

a{
  text-decoration: none;
}
a:hover{
  text-decoration: none;
}

</style>